import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { submit as submitForm, isDirty } from 'redux-form';
import { Button, Header, Modal } from 'semantic-ui-react';
import { toastError, toastSuccess } from 'Common/ToastHelper';
import { get } from 'lodash';

import { ServedItemAccessFieldEnum as Fields } from 'Common/FieldEnum';
import { AssignSitesToServedItemForm } from './components/AssignSitesToServedItemForm';
import { ASSIGN_SITES_TO_SERVED_ITEM_FORM_NAME } from 'Common/FormEnum';
import { resetDirty } from 'State/dirtyTracking/actions';
import MPWWebApi from 'API/MPWApi';

class AssignSitesToServedItem extends Component {
  static props = {
    onClose: PropTypes.func.isRequired,
    name: PropTypes.string.isRequired,
    servedItemId: PropTypes.string.isRequired,
  };

  state = {
    isLoading: false,
  };

  componentWillMount() {
    this.getSelectedSites();
  }

  loading = isLoading => this.setState({ isLoading });

  getSelectedSites = async () => {
    this.loading(true);

    try {
      const response = await MPWWebApi.getGeneric(
        `serveditem/${this.props.servedItemId}/sites`
      );

      this.setState({ selectedSites: response.data.Data.map(s => s.Id) });
      this.loading(false);
    } catch (error) {
      get(error, 'response.data.Errors', [
        { Title: error.response.statusText },
      ]).forEach(error => toastError(error.Title));
    }
  };

  handleSubmit = async selectedSites => {
    const { servedItemId, resetDirty, onClose } = this.props;
    this.loading(true);

    try {
      await MPWWebApi.postGenericInsertUpdate(
        `serveditem/writesitestoserveditem`,
        { servedItemId, ...selectedSites }
      );

      toastSuccess(`Updated sites.`);
    } catch (error) {
      get(error, 'response.data.Errors', [
        { Title: error.response.statusText },
      ]).forEach(error => toastError(error.Title));

      return this.loading(false);
    }

    resetDirty();
    this.loading(false);
    onClose();
  };

  render() {
    const { name, onClose, servedItemId, submitForm, isFormDirty } = this.props;
    const { isLoading, selectedSites } = this.state;
    return (
      <Modal open closeIcon size="large" onClose={onClose}>
        <Header
          icon="building outline"
          content={`Assign sites to served item: ${name}`}
        />
        <Modal.Content>
          {selectedSites && (
            <AssignSitesToServedItemForm
              onSubmit={this.handleSubmit}
              initialValues={{
                [Fields.SiteIds]: selectedSites,
              }}
              servedItemId={servedItemId}
              loading={isLoading}
            />
          )}
        </Modal.Content>
        <Modal.Actions>
          <Button
            positive
            inverted
            color="orange"
            size="big"
            content="Save"
            disabled={!isFormDirty || isLoading}
            onClick={() => submitForm(ASSIGN_SITES_TO_SERVED_ITEM_FORM_NAME)}
          />
        </Modal.Actions>
      </Modal>
    );
  }
}

const mapStateToProps = state => {
  return {
    isFormDirty: isDirty(ASSIGN_SITES_TO_SERVED_ITEM_FORM_NAME)(state),
  };
};

export const AssignSitesToServedItemModal = withRouter(
  connect(
    mapStateToProps,
    {
      submitForm,
      resetDirty,
    }
  )(AssignSitesToServedItem)
);



// WEBPACK FOOTER //
// ./src/pages/serveditemaccesssetup/AssignSitesToServedItemModal.js